import { Link } from 'react-router-dom';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import PageFooter from './components/pageFooter';

export const NotFoundPage = () => {
  return (
    <PageLayout>
      <PageContainer>
        <PageBody>
          <NavigationHeader />
          <PageText>
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <p style={{ fontSize: '1.2rem', marginBottom: '8px' }}>\u2727 page not found \u2727</p>
              <p style={{ color: '#999', marginBottom: '24px' }}>this page doesn't exist or may have moved</p>
              <Link to="/" style={{ marginRight: '16px' }}>back to home</Link>
              <Link to="/shop">browse shop</Link>
            </div>
          </PageText>
          <PageFooter />
        </PageBody>
      </PageContainer>
    </PageLayout>
  );
};
